import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-booking-item-tree-extra-roles-form',
    templateUrl: './editor-booking-item-tree-extra-roles-form.component.html',
    styleUrls: ['./editor-booking-item-tree-extra-roles-form.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemTreeExtraRolesFormComponent implements OnInit, OnDestroy {
  @Input() parentFormGroup: FormGroup;
  @Input() itemTreeExtraRolesForm: FormControl;

  private destroyed$ = new Subject<void>();

  roleNames: { id: string, name: string }[];

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.roleNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(roleNames => this.roleNames = roleNames);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  isDeletable() {
    return this.itemTreeExtraRolesForm.value.length > 0;
  }

  onDelete() {
    this.itemTreeExtraRolesForm.markAsDirty();
    this.itemTreeExtraRolesForm.setValue([]);
    return false;
  }
}
